export default function Portfolio() {
  const projects = [
    {
      title: '大手飲料メーカー',
      category: 'TV CM制作',
      description: '新商品ローンチキャンペーンのメインビジュアルとTVCM制作。ブランドの新しい価値観を表現し、売上150%向上を実現。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20beverage%20commercial%20production%20set%20with%20cameras%2C%20lighting%20equipment%2C%20and%20colorful%20drink%20bottles%20being%20filmed%2C%20modern%20studio%20environment%20with%20red%20and%20orange%20lighting%20accents%2C%20creative%20advertising%20atmosphere&width=400&height=300&seq=wow2&orientation=landscape',
      result: '+150% 売上向上',
      color: 'from-red-500 to-pink-500'
    },
    {
      title: 'IT企業リブランディング',
      category: 'ブランディング',
      description: '老舗IT企業の完全リブランディング。新ロゴ、VI、Webサイト、営業資料まで一貫してデザイン。企業価値向上に貢献。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20IT%20company%20rebranding%20presentation%20with%20new%20logo%20designs%2C%20brand%20guidelines%2C%20and%20digital%20interfaces%20displayed%20on%20multiple%20screens%2C%20contemporary%20office%20meeting%20room%20with%20orange%20and%20red%20ambient%20lighting&width=400&height=300&seq=wow3&orientation=landscape',
      result: '+200% ブランド認知',
      color: 'from-orange-500 to-yellow-500'
    },
    {
      title: 'ファッションブランド',
      category: 'デジタルマーケティング',
      description: '新進ファッションブランドのSNSマーケティング戦略立案・運用。インフルエンサー施策により大幅なフォロワー増を実現。',
      image: 'https://readdy.ai/api/search-image?query=Fashion%20brand%20social%20media%20marketing%20campaign%20setup%20with%20stylish%20clothing%20displays%2C%20smartphone%20screens%20showing%20Instagram%20posts%2C%20creative%20studio%20workspace%20with%20warm%20lighting%20and%20modern%20aesthetic&width=400&height=300&seq=wow4&orientation=landscape',
      result: '+300% フォロワー増',
      color: 'from-yellow-500 to-green-500'
    },
    {
      title: '医療機器メーカー',
      category: '映像制作',
      description: '医療従事者向け製品紹介動画の制作。複雑な技術内容をわかりやすく映像化し、営業効率の大幅改善を実現。',
      image: 'https://readdy.ai/api/search-image?query=Professional%20medical%20device%20video%20production%20studio%20with%20high-tech%20equipment%20being%20filmed%2C%20clean%20modern%20environment%20with%20professional%20lighting%20setup%2C%20medical%20professionals%20reviewing%20footage%20on%20monitors&width=400&height=300&seq=wow5&orientation=landscape',
      result: '+180% 営業効率',
      color: 'from-green-500 to-blue-500'
    },
    {
      title: '飲食チェーン店',
      category: 'Webサイト制作',
      description: '全国展開する飲食チェーンの公式サイト構築。オンライン予約システムと連携し、来店率向上に大きく貢献。',
      image: 'https://readdy.ai/api/search-image?query=Restaurant%20chain%20website%20development%20workspace%20with%20multiple%20monitors%20showing%20food%20photography%2C%20menu%20designs%2C%20and%20booking%20systems%2C%20modern%20web%20development%20office%20with%20warm%20ambient%20lighting&width=400&height=300&seq=wow6&orientation=landscape',
      result: '+220% 来店率',
      color: 'from-blue-500 to-purple-500'
    },
    {
      title: '製造業展示会',
      category: 'イベント企画',
      description: '大手製造業の展示会ブース企画・運営。体験型コンテンツで来場者の関心を引き、過去最高の商談数を達成。',
      image: 'https://readdy.ai/api/search-image?query=Large%20manufacturing%20industry%20trade%20show%20booth%20with%20interactive%20displays%2C%20modern%20exhibition%20design%2C%20professional%20lighting%2C%20visitors%20engaging%20with%20high-tech%20product%20demonstrations%2C%20contemporary%20event%20space&width=400&height=300&seq=wow7&orientation=landscape',
      result: '+250% 商談数',
      color: 'from-purple-500 to-pink-500'
    }
  ];

  return (
    <section id="portfolio" className="py-32 bg-gradient-to-b from-black via-gray-900 to-black relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/3 w-96 h-96 bg-red-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/3 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
      </div>

      <div className="container mx-auto px-6 relative">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-20">
            <div className="inline-block mb-6">
              <span className="text-red-400 text-sm font-bold tracking-widest" style={{ fontFamily: '"Montserrat", sans-serif' }}>PORTFOLIO</span>
            </div>
            <h2 className="text-6xl font-black text-white mb-8" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              実績紹介
            </h2>
            <div className="flex items-center justify-center gap-4">
              <div className="w-32 h-1 bg-gradient-to-r from-transparent via-red-500 to-transparent rounded-full"></div>
              <div className="w-4 h-4 bg-red-500 rounded-full"></div>
              <div className="w-32 h-1 bg-gradient-to-r from-transparent via-orange-500 to-transparent rounded-full"></div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project, index) => (
              <div
                key={index}
                className="group relative bg-white/5 backdrop-blur-xl rounded-3xl border border-red-500/30 overflow-hidden hover:bg-white/10 transition-all hover:shadow-2xl hover:shadow-red-500/50 hover:-translate-y-4 duration-300"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                
                <div className="relative">
                  <div className="relative overflow-hidden">
                    <img 
                      src={project.image}
                      alt={project.title}
                      className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                    <div className={`absolute top-4 left-4 bg-gradient-to-r ${project.color} text-white px-3 py-1 rounded-full text-xs font-bold`} style={{ fontFamily: '"Montserrat", sans-serif' }}>
                      {project.category}
                    </div>
                  </div>
                  
                  <div className="p-6 space-y-4">
                    <h3 className="text-xl font-black text-white" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                      {project.title}
                    </h3>
                    
                    <p className="text-gray-300 text-sm leading-relaxed" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                      {project.description}
                    </p>
                    
                    
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-16">
            <a href="#contact" className="bg-gradient-to-r from-red-500 to-orange-500 text-white px-8 py-4 rounded-full hover:shadow-xl hover:shadow-red-500/50 transition-all font-bold text-lg tracking-wide whitespace-nowrap" style={{ fontFamily: '"Montserrat", sans-serif' }}>
              プロジェクト相談はこちら
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}